










































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment, { Moment } from 'moment';
import AddEditModal from './addEditModal.vue';
import LogsModal from './logsModal.vue';
@Component({
  components: {
    AddEditModal,
    LogsModal,
  },
})
export default class BillDataPage extends Vue {
  /** 列表数据 */
  private dataList: TypeBillData.ListItem[] = [];
  /** 表格列属性 */
  private columns: TypeBase.TableColumn[] = [];
  /** 列表请求状态 */
  private loadingStatus: boolean = false;
  /** 列表勾选 */
  private rowSelection: TypeBase.RowSelection = {};
  /** 选中的项 */
  private selectedList: string[] = [];
  /** 搜索表单 */
  private searchData: TypeBillData.SearchData = this.getInitSearchData();
  /** 上一次请求参数 */
  private lastParams: TypeBillData.SearchData = {};
  /** 页码总数 */
  private total: number = 0;
  /** 时间 */
  private datetimeDefaultValue: Moment[] = [];
  /** 控制新增、编辑弹窗 */
  private addEditVisible: boolean = false;
  /** 控制日志弹窗 */
  private logsVisible: boolean = false;
  /** 行信息 */
  private rowData: TypeBillData.ParentParams = {};
  /** 时间类型枚举 */
  @enumData('Finance/BillDataTimeFieldEnum')
  private billDataTimeFieldEnum: TypeBase.EnumListItem[] = [];
  /** 时间搜索框变动 */
  @Watch('datetimeDefaultValue', { immediate: true })
  private onDatetimeDefaultValueChange(arr: Moment[]): void {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(moment(arr[0]));
      this.searchData.end_time = this.$util.formatDateTime(moment(arr[1]));
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  }
  private created(): void {
    this.setColumns();
    this.queryDataList();
  }
  /**
   * 设置列属性
   */
  private setColumns() {
    this.columns = [
      {
        title: this.t('账户编码'),
        dataIndex: 'account_code',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('抬头'),
        dataIndex: 'title',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('税号'),
        dataIndex: 'tax_no',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('地址'),
        dataIndex: 'address',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('电话'),
        dataIndex: 'phone',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('开户行'),
        dataIndex: 'open_bank_name',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('账号'),
        dataIndex: 'open_bank_account',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('创建时间'),
        dataIndex: 'create_time',
        filterEmpty: true,
      },
      {
        title: this.t('更新时间'),
        dataIndex: 'update_time',
        filterEmpty: true,
      },
      {
        title: this.t('操作'),
        dataIndex: 'operation',
        width: 120,
        fixed: 'right',
        scopedSlots: { customRender: 'operation' },
      },
    ];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: (selectedRowKeys: string[], rowSelection: TypeBillData.ListItem[]) => {
        this.rowSelection.selectedRowKeys = this.selectedList = selectedRowKeys;
        const pendingConfirmList: number[] = [];
      },
    };
  }
  /**
   * 请求列表数据
   */
  @loading('loadingStatus')
  private async queryDataList(): Promise<void> {
    const postData: TypeBillData.SearchData = this.$util.deepCopy(this.searchData);
    this.lastParams = this.$util.deepCopy(postData);
    const { data } = await this.$api.finance.queryBillDataList<TypeBase.ListResult<TypeBillData.ListItem[]>>(postData);
    const { list, total } = data;
    this.dataList = list;
    this.total = total;
  }
  /**
   * 初始化参数
   */
  @userPrefPageSize('billDataList')
  private getInitSearchData(): TypeBillData.SearchData {
    return {
      /** 开始时间 */
      start_time: undefined,
      /** 结束时间 */
      end_time: undefined,
      /** 时间类型 */
      time_filter_field: this.$enum.finance.BillDataTimeFieldEnum.CREATE_TIME,
      /** 发票抬头 */
      title: '',
      /** 税号 */
      tax_no: '',
      page_index: 1,
      page_size: 10,
    };
  }
  /**
   * 页码变动
   */
  private handlePageChange(val: number): void {
    this.searchData.page_index = val;
    this.queryDataList();
  }
  /**
   * 重置页面数据
   */
  private initPage(): void {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
  }
  /**
   * 搜索按钮
   */
  private handleSearch(): void {
    this.initPage();
    this.queryDataList();
  }
  /**
   * 重置
   */
  private handleReset(): void {
    this.searchData = this.getInitSearchData();
    this.initPage();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(180);
    this.$nextTick(() => this.queryDataList());
  }
  /**
   * 导出
   */
  private async handleExport(isAll: boolean): Promise<void> {
    let postData: TypeBillData.ExportSearchData = {};
    if (isAll) {
      postData = { ...this.lastParams };
      delete postData.page_index;
      delete postData.page_size;
      postData.str_id_list = [];
    } else {
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.str_id_list = this.selectedList;
    }
    const { code, data, message } = await this.$api.finance.exportBillDataList<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }
  /**
   * 新增
   */
  private handleAdd() {
    this.rowData.type = this.$enum.common.ModalTypeEnum.ADD;
    this.rowData.title = this.t('新增');
    this.rowData.data = null;
    this.addEditVisible = true;
  }
  /**
   * 编辑
   */
  private handleEdit(record: TypeBillData.ListItem): void {
    this.rowData.type = this.$enum.common.ModalTypeEnum.EDIT;
    this.rowData.title = this.t('编辑');
    this.rowData.data = record;
    this.addEditVisible = true;
  }
  /**
   * 日志
   */
  private handleLog(record: TypeBillData.ListItem): void {
    this.rowData.title = this.t('日志');
    this.rowData.data = record;
    this.logsVisible = true;
  }
}
